import { Box } from '@mui/material'
import { useLoginScreenStyle } from './hooks/useLoginScreenStyleHook'
import LogInMenu from './menus/LogInMenu'
import { useAppStore, useVisibilityStore } from '@/shared/store'
import useAppSkin from '@/shared/hooks/useAppSkin'
import { useNavigate } from 'react-router-dom'
import { settingsPagePath } from '@/shared/constants'

const LoginScreen = () => {
    const { setIsUserLoggedIn, setIsGuest } = useAppStore()
    const { appLoginScreenLogo } = useAppSkin()
    const navigate = useNavigate()
    const {
        containerStyle,
        backgroundImageContainerStyle,
        backgroundGradientOverlayStyle,
        backgroundImageStyle,
        logoStyle,
        contentStyle,
        menusContainerStyle,
    } = useLoginScreenStyle()

    const { setHomeContentVisible, setSettingsContentVisible } =
        useVisibilityStore()
    const handleLogInClick = (shouldOpenDeviceManager?: boolean) => {
        setIsUserLoggedIn(true)
        if (shouldOpenDeviceManager) {
            setSettingsContentVisible()
            navigate(settingsPagePath)
        } else {
            setHomeContentVisible()
        }
    }

    const handleGuestClick = () => {
        setIsGuest(true)
        setIsUserLoggedIn(true)
        setHomeContentVisible()
    }

    return (
        <Box sx={containerStyle}>
            <Box sx={backgroundImageContainerStyle}>
                <Box sx={backgroundGradientOverlayStyle}></Box>
                <Box sx={backgroundImageStyle}></Box>
            </Box>

            <Box sx={contentStyle}>
                <Box sx={logoStyle}>
                    <img src={appLoginScreenLogo} alt="login screen logo" />
                </Box>
            </Box>
            <Box sx={menusContainerStyle}>
                <LogInMenu
                    handleLogInClick={handleLogInClick}
                    handleGuestClick={handleGuestClick}
                />
            </Box>
        </Box>
    )
}

export default LoginScreen
